import { AuthUser } from 'aws-amplify/auth'
import { createGlobalState } from 'react-hooks-global-state'
import { CognitoGroups } from '@npm-client-frontends/client-frontends-shared-types'

export enum AuthSessionState {
  Loading = 'loading',
  Loaded = 'loaded',
  Error = 'error',
}

export type UserAuthSession = {
  userCognitoGroups: CognitoGroups[]
  currentUser: AuthUser | null
  sessionState: AuthSessionState
}

const initialState: UserAuthSession = {
  userCognitoGroups: [],
  currentUser: null,
  sessionState: AuthSessionState.Loading,
}

const { setGlobalState, getGlobalState } = createGlobalState(initialState)

export const convertStringToArray = (inputString: string): CognitoGroups[] => {
  const trimmed = inputString.slice(1, -1).trim()
  if (trimmed.includes(',')) {
    return trimmed.split(',').map((s) => s.trim()) as CognitoGroups[]
  } else {
    return trimmed.split(' ').map((s) => s.trim()) as CognitoGroups[]
  }
}

export const COGNITO_GROUPS_ATTRIBUTE = 'cognito:groups'

export const setUserAuthSession = (user, session) => {
  try {
    const groups = session.tokens?.idToken?.payload?.['cognito:groups'] ?? []
    const parsedGroups =
      typeof groups === 'string'
        ? convertStringToArray(groups)
        : (groups as CognitoGroups[])

    setGlobalState('userCognitoGroups', parsedGroups)

    setGlobalState('currentUser', user)

    setGlobalState('sessionState', AuthSessionState.Loaded)
  } catch (error) {
    console.error('Error fetching user session', error)
    setGlobalState('sessionState', AuthSessionState.Error)
  }
}

export const setUserAuthSessionErrorState = () => {
  setGlobalState('sessionState', AuthSessionState.Error)
}

export const getUserAuthSession = (): UserAuthSession => ({
  userCognitoGroups: getGlobalState('userCognitoGroups'),
  currentUser: getGlobalState('currentUser'),
  sessionState: getGlobalState('sessionState'),
})
